import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ManagementApiService } from '../../../../services';
import { SharedContentCategory } from '../../../settings/enums/shared-content-category.enum';
import { SharedContentModel } from '../../../settings/models/general/shared-content-model';
import { Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-home-hero',
    templateUrl: './home-hero.component.html',
    styleUrls: ['./home-hero.component.scss'],
    standalone: false,
})
export class HomeHeroComponent implements OnInit, OnDestroy {
    sharedContentsList: SharedContentModel[] = null;
    userLanguageSub: Subscription;
    images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);

    constructor(
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private user_utlity: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private ngxUiLoaderService: NgxUiLoaderService
    ) {}

    ngOnInit(): void {
        this.userLanguageSub = this.globalEmittersService.isUserDefaultsLoaded.subscribe((res) => {
            if (res) {
                this.getSharedContents(this.translocoService.getActiveLang());
            }
        });
    }

    async getSharedContents(language: string) {
        try {
            // this.ngxUiLoaderService.start();
            let temp = await this.mgmtApi.getSharedContentForHomePage(SharedContentCategory.HeroImages, language).toPromise();
            if (temp.success === true) {
                this.sharedContentsList = temp.response.filter((item) => item.imageLocation == 1 || item.imageLocation == 3);

                /* Notes: Image with byte stream conversion where  I create new list that display ui putting document api call and also add extension to display in ui*/

                // this.sharedContentsList.map(x=>{
                //   let obj:any={}
                //   obj.heading=x.heading;
                //   obj.subHeading=x.subHeading;
                //   obj.navigationText=x.navigationLink;
                //  if(x.image){
                //  obj.extension=x.image.substring(x.image.lastIndexOf('.')+1)
                //   this.documentApiService.getImgBytes([x?.image]).toPromise().then((resp)=>{
                //     obj.image=resp.response.content;
                //   });
                //  }
                //  this.displayHeroImgList.push(obj)
                // })
            } else {
                this.user_utlity.errorModelPopup(temp.message);
            }
            // this.ngxUiLoaderService.stop();
            this.cd.markForCheck();
        } catch (e) {
            // this.ngxUiLoaderService.stop();
        }
    }

    navigatetoPage(event, heroImageData) {
        window.open(heroImageData.navigationLink, '_blank'); // Opens a link in new window
        //document.location.href = heroImageObject.navigationLink; //opens a link in same window
    }

    ngOnDestroy() {
        if (this.userLanguageSub) {
            this.userLanguageSub.unsubscribe();
        }
    }
}
